// Every callable-function failure was being reported with the same twelve-line
// dialog config. This keeps that — and the confirmation prompts guarding
// destructive actions — in one place.
export default {
  methods: {
    alertError(error) {
      this.$buefy.dialog.alert({
        title: (error && error.code) || "Something went wrong",
        message: (error && error.message) || String(error),
        type: "is-danger",
        hasIcon: true,
        icon: "close-circle",
        ariaRole: "alertdialog",
        ariaModal: true
      });
    },

    toastSuccess(message) {
      this.$buefy.toast.open({ message, type: "is-success" });
    },

    /**
     * Confirmation gate for anything destructive or hard to undo.
     * Pass `severe: true` for actions that affect players mid-game — it makes
     * the operator type the confirmation word instead of tapping once.
     */
    confirmDanger({ title, message, confirmText, severe = false, requireWord = "STOP", onConfirm }) {
      if (!severe) {
        return this.$buefy.dialog.confirm({
          title,
          message,
          confirmText,
          cancelText: "Cancel",
          type: "is-danger",
          hasIcon: true,
          icon: "alert",
          ariaRole: "alertdialog",
          ariaModal: true,
          onConfirm
        });
      }

      this.$buefy.dialog.prompt({
        title,
        message: `${message}<br/><br/>Type <strong>${requireWord}</strong> to confirm.`,
        confirmText,
        cancelText: "Cancel",
        type: "is-danger",
        hasIcon: true,
        icon: "alert",
        inputAttrs: { placeholder: requireWord, maxlength: requireWord.length + 4 },
        trapFocus: true,
        onConfirm: (value) => {
          if (String(value).trim().toUpperCase() !== requireWord) {
            return this.$buefy.toast.open({ message: "Confirmation did not match — nothing was changed.", type: "is-warning" });
          }
          onConfirm();
        }
      });
    }
  }
};
